import { Helmet } from "react-helmet";
import { useAutoScrollOnLoad } from "../../hooks/autoScrollOnLoad";
import ContactListSection from "../../sections/ContactList";
import { useAuth } from "../../contexts/AuthCtx";
import { useEffect } from "react";

export default function AIMLPage() {

    const authCtx = useAuth();

    useEffect(() => {
        authCtx.set_nav_mode('normal');
    }, []);

    useAutoScrollOnLoad()

    return (
        <>
            <Helmet>
                <title>AI/ML Solutions - Equibre</title>
                <meta name="description" content="Crafting Unique Online Experiences with Tailored Website Solutions." />
            </Helmet>
            <section className="page-header-section short-blogs-section">
                <div className="inner">
                    <div className="header">
                        <h1>AI/ML Solutions</h1>
                        <p>We develop AI and ML solutions that make data work smarter—whether it’s automating tasks, analyzing patterns, or processing text, images, and video. From predictive models to intelligent automation, we help businesses build efficient, data-driven systems.</p>
                        {/* <a href="https://blog.equibre.com/custom-website-development/">Read more &rarr;</a> */}
                    </div>
                    <div className="content">
                        <h3>Our Innovative Projects: Transforming Challenges into Solutions</h3>
                        <ul style={{listStyle: "disc", marginLeft: "20px"}}>
                            <li><strong>AI-Powered Surveillance System for Government:</strong> Revolutionized government operations by implementing AI for automated vehicle entry and face recognition at entry points, eliminating time delays and unauthorized access.</li>
                            <li>
                                <strong>Multi-Agent System:</strong><br /><br />
                                Developed AI agent that support neighbors-chat, simulating like human and detecting emotion.<br /><br />
                                Developed fast, and extensible multimodal LLM that can understand text as well as human speech, without the need for a separate Audio Speech Recognition (ASR) stage.<br /><br />
                                Designed robust Orchestrating sys, routing sys and Collaborating sys.<br /><br />
                                Implemented Agent accross the healthcare, marketing, and retail industries.
                            </li>
                            <li><strong>Seamless Employee Vehicle Authentication:</strong> Automated entry system using dynamic QR codes and number plate detection, reducing queues and enhancing security at entry gates.</li>
                            <li>
                                <strong>Personalized Recommendation System for Retail:</strong><br /><br />
                                Built a highly scalable and modular real-time personalized recommender on top of H&M retail platform.<br /><br />
                                Designed a strategy similar to what TikTok employs for short videos.<br /><br />
                                Implemented 4-stage architecture to build system, handling recommendations from a catalog of milions of items.<br /><br />
                                Designed two-tower model, a flexible neural network design, creating embeddings for users and fashion items.
                            </li>
                            <li><strong>Advanced Face Recognition for Identity Verification:</strong> Developed a facial recognition system to authenticate employees, even in cases of lost ID cards, using live face comparisons and database validation.</li>
                            <li><strong>Efficient Multi-Passenger Authentication Workflow:</strong> Created a robust workflow to authenticate multiple passengers within vehicles, ensuring secure and swift entry.</li>
                            <li>
                                <strong>AI to Mimic personal and unique writing style and voice:</strong><br /><br />
                                AI character that learns to write article, post like somebody using owner's writing style and personality by incorporating its style and personality into an LLM.<br /><br />
                                Architecting and building a real-world LLM system from start to finish - from data collection to deployment.<br /><br />
                                Leveraging MLOps best practices, such as experiment trackers, model registries, prompt monitoring, and versioning.<br /><br />
                                Splitting the monolithic ML system into 4 Python micro services - Data collection, Feature, training and inference pipeline.
                            </li>
                        </ul>
                        <p>Our solutions demonstrate a commitment to innovation and security, providing scalable and effective systems tailored to specific operational needs.</p>
                    </div>
                </div>
            </section>
            <ContactListSection />
        </>
    );
}
